import { render, staticRenderFns } from "./DesksPage.vue?vue&type=template&id=2362e2ca&scoped=true"
import script from "./DesksPage.vue?vue&type=script&lang=js"
export * from "./DesksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362e2ca",
  null
  
)

export default component.exports